import { withTranslation, TFunction } from "react-i18next";
import { SvgIcon } from "../../common/SvgIcon";

import {
  Chat,
} from "./styles";
import { Box } from "@mui/material";

interface SocialLinkProps {
  href: string;
  src: string;
}

const Footer = ({ t }: { t: TFunction }) => {
  // const handleChange = (language: string) => {
  //   i18n.changeLanguage(language);
  // };

  const SocialLink = ({ href, src }: SocialLinkProps) => {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        key={src}
        aria-label={src}
      >
        <SvgIcon src={src} width="25px" height="25px" />
      </a>
    );
  };

  return (
    <>
        <Box
          display="flex"
          width="100%"
          justifyContent="space-around"
          alignItems="center"
          marginTop="1rem"
          marginBottom="1rem"
          padding="1rem">
            <a href="mailto:uanjumm@gmail.com">
              <Chat>{t(`Let's Chat`)}</Chat>
            </a>
            {/* <Para>
              {t(`Copyright © 2023 Uzair Anjum`)}
            </Para> */}
              <SocialLink
                href="https://github.com/uanjum"
                src="github.svg"
              />
              <SocialLink
                href="https://www.linkedin.com/in/uzairanjum/"
                src="linkedin.svg"
              />
        </Box>
        </>
  );
};

export default withTranslation()(Footer);
